module.exports = __webpack_public_path__ + "img/vector-bg-11.368436b4.svg";